import type { AppRouteRecordRaw } from "#src/router/types";

import { HomeOutlined } from "@ant-design/icons";
import ContainerLayout from "#src/layout/container-layout";
import { $t } from "#src/locales";
import { home } from "#src/router/extra-info";
import { createElement, lazy } from "react";

const Home = lazy(() => import("#src/pages/home"));

const routes: AppRouteRecordRaw[] = [
	{
		path: "/home",
		Component: ContainerLayout,
		handle: {
			order: home,
			title: $t("common.menu.home"),
			icon: createElement(HomeOutlined),
		},
		children: [
			{
				index: true,
				Component: Home,
				handle: {
					title: $t("common.menu.home"),
					icon: createElement(HomeOutlined),
				},
			},
		],
	},
];

export default routes;
